import { memo } from 'react'

const FCScatterChart = () => null // ! TODO

export const ScatterChart = memo(FCScatterChart)
